export default function Reducer(state, action) {
  switch (action.type) {
    case 'LOAD_ENTERPRISE':
      return {
        ...state,
        enterpriseName: action.enterpriseAttributes.name,
        enterpriseSizeId: action.enterpriseAttributes.company_size_id,
        enterpriseIndustryIds: action.enterpriseAttributes.industry_ids,
        enterpriseLogo: action.enterpriseAttributes.logo.includes('leggup_logo')
          ? null : action.enterpriseAttributes.logo,
        enterpriseColor: action.enterpriseAttributes.primary_color,
        enterpriseBrandingAvailable: action.enterpriseAttributes.branding_available,
      };

    case 'UPDATE_ENTERPRISE':
      return {
        ...state,
        enterpriseName: action.enterpriseAttributes.name,
        enterpriseSizeId: action.enterpriseAttributes.company_size_id,
        enterpriseIndustryIds: action.enterpriseAttributes.industry_ids,
        enterpriseLogo: action.enterpriseAttributes.logo,
        enterpriseColor: action.enterpriseAttributes.primary_color,
        enterpriseBrandingAvailable: action.enterpriseAttributes.branding_available,
      };

    default:
      throw Error(`Unknown action: ${action.type}`);
  }
}
